import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionProps, AccordionSummaryProps, Box, Button, Checkbox, Chip, FormControlLabel, Stack, styled, Switch } from "@mui/material";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { Article } from "../_/components/Article";
import { Column, Row } from "../_/components/organization";
import { Ref } from "../_/components/Reference";
import { BodyStat, SharpnesStat, SoulStat } from '../_/components/Stats';
import { locale } from '../content/locale';
import { SkillDef, skills, Tag, tagName, tags } from "../content/skills";

export const Skills = () => {
    const [selectedTags, setSelectedTags] = useState<Tag[]>(tags);
    const [filterAny, setFilterAny] = useState(true);
    const [showOnlyBaiscSkills, setShowOnlyBasicSkills] = useState(false);
    const [bodyR, setBodyR] = useState(3)
    const [sharpnesR, setSharpnesR] = useState(3)
    const [soulR, setSoulR] = useState(3)

    let skls = skills();
    // if (showOnlyBaiscSkills)
    //     skls = skls.filter(s => s.children?.length == 0)

    skls = skls.filter(skill => skill.requirements.body <= bodyR && skill.requirements.sharpeness <= sharpnesR && skill.requirements.spirit <= soulR)


    function handleToggleTags(tags: Tag[]): void {
        setSelectedTags(tags)
    }

    return (
        <>
            <Article.Title>
                {locale.skills.capitalize()}
            </Article.Title>
            <Article.Body>
                {locale.skills.capitalize()} dają postaci unikalne możliwości rozwoju. Niektóre z nich są pasywne a innych można użyć jako akcji.
            </Article.Body>

            <Article.SubTitle>
                Nauka
            </Article.SubTitle>
            <Article.Body>
                Zdolności uczysz się awansując na niektóre <Ref>poziomy</Ref> oraz gdy podnosisz <Ref>Umysł</Ref>.
            </Article.Body>

            <Article.SubTitle>
                Wymagania
            </Article.SubTitle>
            <Article.Body>
                Nauka niektórych zdolności może wymagać posiadania innej zdolności, określonych statystyk lub innych wymagań.
            </Article.Body>

            <Article.Title>
                Lista zdolności
            </Article.Title>

            <Typography>
                Filtry
            </Typography>
            <Box sx={{ border: '1px solid', borderRadius: 1, padding: 2, maxWidth: '320px' }}>
                <Box>
                    <Row gap={3}>
                        <Stack direction="column">
                            <Typography component="legend">Ciało</Typography>
                            <BodyStat value={bodyR} onChange={(s) => setBodyR(s)} />
                        </Stack>
                        <Stack direction="column">
                            <Typography component="legend">Ostrość</Typography>
                            <SharpnesStat value={sharpnesR} onChange={(s) => setSharpnesR(s)} />
                        </Stack>
                        <Stack direction="column">
                            <Typography component="legend">Dusza</Typography>
                            <SoulStat value={soulR} onChange={(s) => setSoulR(s)} />
                        </Stack>    
                    </Row>
                    <FormControlLabel labelPlacement='start' control={<Checkbox defaultChecked checked={showOnlyBaiscSkills} onChange={(event) => setShowOnlyBasicSkills(event.target.checked)} />} label="Tylko podstawowe" />
                </Box>
                <Box textAlign={'right'}>
                    {`${skls.length}`}
                </Box>
            </Box>
            <Box>
                {true && skls.sort((a, b) => a.name.localeCompare(b.name) ).map(skill => <SkillNew skill={skill} onlyBasic={showOnlyBaiscSkills} />)}
            </Box>
        </>
    )
}

interface TagSelectorProps {
    selectedTags: Tag[];
    filterAny: boolean;
    onToggleTag: (tags: Tag[]) => void;
    onFilterChange: React.Dispatch<React.SetStateAction<boolean>>;
}

const TagSelector = ({ selectedTags,
    filterAny,
    onToggleTag,
    onFilterChange }: TagSelectorProps) => {

    const handleToggleTag = (tag: Tag) => {
        const newTags = selectedTags.includes(tag) ? selectedTags.filter(t => t !== tag) : [...selectedTags, tag]
        onToggleTag(newTags);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onFilterChange(event.target.checked);
    };

    return (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h6">Filtr</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', marginTop: 1 }}>
                {tags.map((tag) => (
                    <Chip
                        key={tag}
                        label={tagName(tag)}
                        onClick={() => handleToggleTag(tag)}
                        color={selectedTags.includes(tag) ? 'primary' : 'default'}
                        sx={{ margin: 0.5 }}
                    />
                ))}

            </Box>
            <Row>

                <Column>
                    <Row>
                        <Button variant="outlined" size="small" onClick={() => onToggleTag(tags)}> Zaznacz wszystkie </Button>  <Button variant="outlined" size="small" onClick={() => onToggleTag([])} > Odznacz wszystkie </Button>
                    </Row>
                    <Typography variant="button"> pokaż zdolności zawierające tagi </Typography>
                    <Row>
                        <Typography variant="overline" align="center"> wszystkie zaznaczone </Typography>

                        <Switch
                            onChange={handleChange}
                            checked={filterAny}
                        />

                        <Typography variant="overline">dowolny zaznaczony</Typography>

                    </Row>
                </Column>

            </Row>
        </Box>
    );
};

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const SkillNew = ({ skill, onlyBasic }: { skill: SkillDef, onlyBasic: boolean }) => {
    return (
        <>
            {skill.children && !onlyBasic && skill.children?.length > 0 ?
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Skill skill={skill}></Skill>

                    </AccordionSummary>
                    <AccordionDetails>
                        {skill.children?.map(s =>
                            <div style={{ marginLeft: '48px' }}>
                                <Skill skill={s}></Skill>
                            </div>
                        )}
                    </AccordionDetails>
                </Accordion>
                :
                <Accordion>
                    <AccordionSummary expandIcon={null} >
                        <div style={{ marginLeft: '24px' }}>
                            <Skill skill={skill}></Skill>
                        </div>
                    </AccordionSummary>
                </Accordion>
            }
        </>

    )
}

const Skill = ({ skill }: { skill: SkillDef }) => {
    return (
        <Column style={{ userSelect: 'text' }}>
            <Stack spacing={1} direction="row">
                <Typography variant="h5" gutterBottom >
                    {skill.name}
                </Typography>

                {/* <Chip label={"koszt:" + skill.level} size="small" /> */}
            </Stack>
            <Row flexWrap="wrap">
                {skill.tags.map(tag =>
                    <Chip label={tagName(tag)} size="small" />
                )}

            </Row>
            <Typography gutterBottom variant="body1" marginBottom={"16px"} align="justify">
                {skill.description}
            </Typography>
        </Column>

    )
}